import { useTranslation } from 'react-i18next';

export function HeroSection() {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d520c47c789b0d072d14d5808ef44cb9.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-blue-800/80 to-transparent"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            {t('hero_main_title')}
            <br />
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              {t('hero_main_subtitle')}
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-4 leading-relaxed">
            {t('hero_company_intro')}<strong>{t('hero_company_year')}</strong>{t('hero_company_desc')}
          </p>
          
          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            {t('hero_business_desc')}<strong>{t('hero_product_1')}</strong>、<strong>{t('hero_product_2')}</strong>、<strong>{t('hero_product_3')}</strong>{t('hero_business_coverage')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={scrollToContact}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg text-base font-medium transition-all duration-300 hover:bg-blue-700 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_contact')}
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('intro');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-base font-medium transition-all duration-300 hover:bg-white hover:text-blue-600 whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_learn')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
